import Axios from 'axios'
import store from '@/store/index.js'
import itemTrim from '@/script/trim/trim.js'
import { Promise } from 'core-js';
let router = null;
let root = process.env.VUE_APP_PACACLOUND_ROOT;
function errorThrow(err){
    if(!router){
        router = window.vue.$router;
    }
    let errorResponse = {
        error_status: err.response.status,
        error_message: err.response.data.message
    };
    if(err.response.status == '400'){
        console.log('catch error 400');
    } else if(err.response.status == '401'){
        store.commit({
            type: "setUserInfo",
            userInfo: null
        })
        window.vue.$router.push(`${process.env.VUE_APP_PACACLOUND_ROOT}/login`);
    } else if(err.response.status == '403'){
        console.log('catch error 403');
    } else if(err.response.status == '404'){
        console.log('catch error 404');
    } else if(err.response.status == '408'){
        console.log('catch error 408');
    } else{
        console.log(`uncatch error ${err.response.status}`);
    }
    return errorResponse
}
Axios.defaults.headers['Content-type'] = "application/json";
function axiosEntity(){
    return Axios.create({
        baseURL: 'https://api.paca.com.tw/api/v1/',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': `${store.state.userInfo ? store.state.userInfo.api_token : ''}`
        },
        retry: 5,
        retryDelay: 1000
    })
}
let pacaConnection = axiosEntity();

export function getUserLogin(){
    return new Promise((resolve) => {
        pacaConnection.get('/member/login').then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}
export function getServiceSite(site_code){
    if(!site_code){
        site_code = '';
    }else{
        site_code = '/' + site_code;
    }
    return new Promise((resolve) => {
        pacaConnection.get(`/member/site${site_code}`).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function getServiceToken(token_id){
    if(!token_id){
        token_id = '';
    }else{
        token_id = '/' + token_id;
    }
    return new Promise((resolve) => {
        pacaConnection.get(`member/tokens${token_id}`).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function getNtpReportList(){
    return new Promise((resolve) => {
        pacaConnection.get(`services/reports/ntp`).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function getPartnerAllRegInfo(optional){
    return new Promise((resolve) => {
        pacaConnection.get(`/partner/reg${optional ? '/' + optional : ''}`).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function getAdminAllRegInfo(optional){
    return new Promise((resolve) => {
        pacaConnection.get(`/admin/reg${optional ? '/' + optional : ''}`).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function getAdminTokenList(){
    return new Promise((resolve)=>{
        pacaConnection.get('/admin/token/siteowner').then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function getAdminUserList(){
    return new Promise((resolve) => {
        pacaConnection.get('/admin/member').then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function getAdminSiteOwnerList(){
    return new Promise((resolve) => {
        pacaConnection.get('/admin/siteowner').then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function getAdminAgnetList(){
    return new Promise((resolve)=> {
        pacaConnection.get('/admin/agent').then((res) => {
            resolve(res.data)
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postSignIn(email,password){
    let data = {
        email: email,
        password: password
    }
    data = itemTrim(data);
    return new Promise((resolve) => {
        pacaConnection.post('/member/registration',data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postUserLogin(user_email,user_password){
    let data = {
        email: user_email,
        password: user_password
    }
    data = itemTrim(data);
    return new Promise((resolve) => {
        pacaConnection.post('/member/login',data).then((res) => {
            store.commit({
                type: 'setUserInfo',
                userInfo: res.data
            })
            pacaConnection = axiosEntity();
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postServiceSiteSearch(keyword, optional){
    let data = {
        "search": keyword
    }
    if(optional){
        data.optional = optional;
    }
    return new Promise((resolve) => {
        pacaConnection.post('/member/site/search', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postServiceSiteAdd(data){
    return new Promise((resolve) => {
        pacaConnection.post('/member/site', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postServiceTokenCreate(data){
    return new Promise((resolve) => {
        pacaConnection.post('/member/tokens', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postServiceTokenSearch(data){
    return new Promise((resolve) => {
        pacaConnection.post('member/tokens/search', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postPartnerRegSearch(keyword, optional){
    let data = {
        "search": keyword
    }
    if(optional){
        data.optional = optional;
    }
    return new Promise((resolve) => {
        pacaConnection.post('/partner/reg/search', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postAdminRegSearch(keyword, optional){
    let data = {
        "search": keyword
    }
    if(optional){
        data.optional = optional;
    }
    return new Promise((resolve) => {
        pacaConnection.post('/admin/reg/search', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postPartnerRegGroupInfo(data){

    return new Promise((resolve) => {
        pacaConnection.post('/partner/reg/group', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postAdminRegGroupInfo(data){

    return new Promise((resolve) => {
        pacaConnection.post('/admin/reg/group', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postAdminHistorySearch(keyword){
    let data = {
        "search": keyword,
        "status": 10000,
        "sort": "created",
    }
    return new Promise((resolve) => {
        pacaConnection.post('/admin/reg/search', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postLogout(){
    return new Promise((resolve) => {
        pacaConnection.post('/member/logout').then((res) => {
            store.commit({
                type: "setUserInfo",
                userInfo: null
            })
            window.vue.$router.push(`${process.env.VUE_APP_PACACLOUND_ROOT}/login`);
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function postForgetPassword(email,password){
    let data = {
        email: email,
        password: password
    }
    data = itemTrim(data);
    return new Promise((resolve) => {
        pacaConnection.post('/member/password/forget', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
    
}

export function putServiceToken(id, data){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/tokens/${id}`, data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putAdminUserInfo(id,data){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/update/${id}`, data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putUserIdentity(id,identity){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/permission/identities/${id}/${identity}`).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putUserLock(id){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/permission/lock/${id}`).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putUserUnLock(id){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/permission/unlock/${id}`).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putAgentPrivacy(email,privacy){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/agent/${email}`, privacy).then((res)=>{
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putMemberNickname(id, data){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/update/${id}`, data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putMemberPassword(oldPassword,newPassword){
    let data = {
        password: oldPassword,
        new_password: newPassword
    }
    data = itemTrim(data);
    return new Promise((resolve) => {
        pacaConnection.put('/member/password', data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putPartnerRegSetting(data){
    return new Promise((resolve) => {
        pacaConnection.put("/partner/reg/setting", data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })  
}

export function putRegSetting(data){
    return new Promise((resolve) => {
        pacaConnection.put("/admin/reg/setting", data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })  
}

export function putAdminRegExtraInfo(data){
    return new Promise((resolve) => {
        pacaConnection.put("/admin/regextra", data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putAdminRegExtraInfoCollectionMark(data){
    return new Promise((resolve) => {
        pacaConnection.put("/admin/regextra/setting", data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putAdminRegExtraInfoServiceReport(data){
    return new Promise((resolve) => {
        pacaConnection.put("/services/reports/ntp", data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putAdminTokenListItem(id,data){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/tokens/${id}`, data).then((res) => {
            resolve(res.data);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putAdminTokenLock(email){
    return new Promise((resolve) => {
        pacaConnection.put(`/admin/token/lock/${email}`).then((res) => {
            resolve(res);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putAdminTokenUnLock(email){
    return new Promise((resolve) => {
        pacaConnection.put(`/admin/token/unlock/${email}`).then((res) => {
            resolve(res);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function putAdminUserPermissionIdentity(id,identity){
    return new Promise((resolve) => {
        pacaConnection.put(`/member/permission/identities/${id}/${identity}`).then((res) => {
            resolve(res);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}

export function DeleteServiceSite(site_code){
    return new Promise((resolve) => {
        pacaConnection.delete(`/member/site/${site_code}`).then((res) => {
            resolve(res);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}
export function deleteServiceToken(token_id){
    return new Promise((resolve) => {
        pacaConnection.delete(`member/tokens/${token_id}`).then((res) => {
            resolve(res);
        }).catch((err) => {
            resolve(errorThrow(err));
        })
    })
}
